<template>
    <el-dropdown
        ref="dropdown"
        trigger="click"
        :hide-on-click="false"
        @visible-change="handleChangeVisibility"
    >
        <el-button
            :disabled="isOpenFilterDropdown"
            class="el-dropdown-link btn-outline"
        >
            Filter
        </el-button>
        <el-dropdown-menu slot="dropdown" class="filter-dropdown-container">
            <h2 class="text-center" style="color:#606266; margin-bottom:40px;">Filter</h2>
            <el-row
                :gutter="20"
                class="mt"
                type="flex"
                justify="space-between"
                align="middle"
            >
                <el-col :span="8">
                    <span class="txt-filter">Account Status:</span>
                </el-col>
                <el-col :span="12" class="float-right" >
                    <el-select
                        v-if="fixedstatus==false"
                        :value="filterDropdownCase.account_status"
                        @change="$emit('update:filterDropdownCase', {...filterDropdownCase, account_status: $event})"
                        placeholder="Select status"
                    >
                        <el-option v-for="item in account_status"
                        :key="item.value" :label="item.text" :value="item.value"></el-option>
                    </el-select>
                    <el-select
                        v-else
                        :value="filterDropdownCase.account_status"
                        @change="$emit('update:filterDropdownCase', {...filterDropdownCase, account_status: $event})"
                        placeholder="Select status"
                    >
                        <el-option label="Review" :value="1"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row
                :gutter="20"
                class="mt"
                type="flex"
                justify="space-between"
                align="middle"
            >
                <el-col :span="8" class="text-md-left col-middle">
                    <span class="txt-filter">Package:</span>
                </el-col>
                <el-col :span="12" class="float-right col-middle">
                    <el-select
                        :value="filterDropdownCase.package_code"
                        @change="$emit('update:filterDropdownCase', {...filterDropdownCase, package_code: $event})"
                        placeholder="Select package"
                    >
                    <el-option v-for="item in package_code"
                        :key="item.value" :label="item.text" :value="item.value"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row
                :gutter="20"
                class="mt"
                type="flex"
                justify="space-between"
            >
                <el-col :span="8" class="text-md-left" style="margin-top: 8px">
                    <span class="txt-filter">Subscription type:</span>
                </el-col>
                <el-col :span="12" class="float-right">
                    <div style="margin-top:8px">
                        <el-radio-group
                            :value="filterDropdownCase.subscription_type"
                            @input="$emit('update:filterDropdownCase', {...filterDropdownCase, subscription_type: $event})"
                        >
                            <el-radio :value="null" :label="null">All</el-radio>
                            <el-radio value="M" label="M">Monthly</el-radio>
                            <el-radio value="A" label="A">Annual</el-radio>
                        </el-radio-group>
                    </div>
                </el-col>
            </el-row>
            <el-row
                v-if="dateSort"
                :gutter="20"
                style="margin-top:-20px"
                type="flex"
                justify="space-between"
            >
                <el-col :span="8" class="text-md-left">
                    <span class="txt-filter">Date sorting</span>
                </el-col>
                <el-col :span="12" class="float-right">
                    <div>
                        <el-checkbox
                            :value="filterDropdownCase.expire_within"
                            @input="$emit('update:filterDropdownCase', {...filterDropdownCase, expire_within: $event})"
                        >
                            Expire within 7 days
                        </el-checkbox>
                    </div>
                </el-col>
            </el-row>
            <el-row
                :gutter="20"
                style="margin-top:40px;"
                type="flex"
                justify="center"
                align="center"
            >
                <el-col :span="6">
                    <slot name="closeFilter" />
                </el-col>
                <el-col class="float-right" :span="6">
                    <slot name="searchFilter" />
                </el-col>
            </el-row>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    name: 'FilterDropdown',
    props: {
        dateSort: { type: Boolean, default: true },
        fixedstatus: { type: Boolean, default: false },
        isOpenFilterDropdown: { type: Boolean, default: false },
        filterDropdownCase: { type: Object,
            default: () => ({
                account_status: { type: Number, default: null },
                package_code: { type: String, default: '' },
                subscription_type: { type: String, default: null },
                expire_within: { type: Boolean, default: false }
            })
        },
        handleChangeVisibility: { type: Function }
    },
    data () {
        return {
            package_code: [
                {
                    value: null,
                    text: 'All'
                },
                {
                    value: 'BRO',
                    text: 'Bronze'
                },
                {
                    value: 'SIL',
                    text: 'Silver'
                },
                {
                    value: 'GOL',
                    text: 'Gold'
                },
                {
                    value: 'PLA',
                    text: 'Platinum'
                }
            ],
            account_status: [
                {
                    value: null,
                    text: 'All'
                },
                {
                    value: 2,
                    text: 'Active (N)'
                },
                {
                    value: 1,
                    text: 'Review'
                },
                {
                    value: 3,
                    text: 'Soft Suspend'
                },
                {
                    value: 4,
                    text: 'Inactive'
                }
            ]
        }
    },
    created () {},
    methods: {}
}
</script>
<style lang="scss" scoped>
.filter-dropdown-container {
    width: 504px;
    padding: 24px 47px;
}
.mt {
    margin-top: 23px;
}
::v-deep .el-radio {
    margin-top: 0px;
    margin-bottom: 44px
}
.col-middle {
    align-self: middle;
}
::v-deep .el-button {
    span .el-icon--right {
        display: none;
    }
}
::v-deep .el-radio {
    margin-top: 8px;
    width: 100%;
}
.txt-filter{
    color: #606266 !important;
}
.btn-outline {
    color: #367e7f !important;
    background: #ffffff !important;
    border-color: #367e7f !important;
    width: 90px;
    height: 40px;
}
.btn-pdf {
    color: #409eff !important;
    background: #ecf5ff !important;
    border-color: #b3d8ff !important;
}
</style>
